module.exports = "https://trybtryb-legacy.web.app/img/typeform.658341e3.svg";